import { Extension } from '../types'

interface PartitionedExtensions {
  availableExtensions: Extension[]
  comingSoonExtensions: Extension[]
}

/**
 * Splits the visible extensions into the ones ready to use and the ones shown in the 'coming soon' section. Hidden extensions are dropped.
 */
export const partitionExtensions = (extensions: Extension[]): PartitionedExtensions => {
  const visibleExtensions = extensions.filter(extension => extension.isVisible)

  return {
    availableExtensions: visibleExtensions.filter(extension => extension.isAvailable),
    comingSoonExtensions: visibleExtensions.filter(extension => !extension.isAvailable),
  }
}
